/* eslint-disable */
import api from '@/services/api';
import store from '@/store';

/**
 * pega um array de qualquer coisa e envolve cada elemento num array (a menos que ele já seja um)
 * @param {any[]} permissions array of any
 * @return {any[][]}
 * @example
 * arrayfy([['admin'], 'baunilha', ['laranja', 'banana'], true])
 * // => [['admin'], ['baunilha'], ['laranja', 'banana'], [true]]
 */
const arrayfy = (arr) => arr.map((el) => (Array.isArray(el) ? el : [el]));
const permMatch = (userPermissions) => (permissions) => permissions.every((p) => userPermissions.includes(p));

class LoginManager {
  /**
   *
   * @param {string} apiUrl
   * @param {Storage} storage
   * @param {string} prefix
   */
  constructor(apiUrl, storage = localStorage, prefix = '_auth_') {
    if (storage && storage.getItem && storage.setItem && storage.removeItem) { // verify storage
      this._storage = storage;
    } else {
      throw new Error('Invalid Storage');
    }
    this._api = apiUrl;
    this._bearer = `${prefix}bearer`;
    this._user = `${prefix}user`;
    this._unidade = `${prefix}unidade`;
    this._configuracao = `${prefix}configuracao`
  }

  async login(registro, senha) {
    const { error, usuario, token } = await api.execute('post', this._api, null, { registro, senha });
    if (error) {
      return { success: false, error: error.errorMessage };
    }
    this._storage.setItem(this._bearer, token);
    this._storage.setItem(this._user, JSON.stringify(usuario));
    this._storage.setItem(this._configuracao, JSON.stringify(store.state.configuracao))
    return { success: true, error: null };
  }

  logout() {
    this._storage.removeItem(this._bearer);
    this._storage.removeItem(this._user);
    this._storage.removeItem(this._unidade);
    this._storage.removeItem(this._configuracao)
    store.commit('setUnidade', null);
  }

  isLoggedIn() {
    const bearer = this._storage.getItem(this._bearer);
    return Boolean(bearer);
  }

  getUser() {
    if (!this.isLoggedIn()) return null;
    const user = this._storage.getItem(this._user);
    try {
      return JSON.parse(user);
    } catch (error) {
      this.logout();
      return null;
    }
  }

  setUser(usuario) {
    try {
      this._storage.setItem(this._user, JSON.stringify(usuario));
      return true;
    } catch (error) {
      this.logout();
      return null;
    }
  }

  getUnidade() {
    if (!this.isLoggedIn()) return null;
    const unidade = this._storage.getItem(this._unidade);
    try {
      return JSON.parse(unidade);
    } catch (error) {
      this.logout();
      return null;
    }
  }

  setUnidade(unidade) {
    try {
      store.commit('setUnidade', unidade);
      this._storage.setItem(this._unidade, JSON.stringify(unidade));
      return true;
    } catch (error) {
      this.logout();
      return null;
    }
  }

  setConfiguracao(conf, update = false) {
    try {
      if (this._storage.getItem(this._configuracao) && !update) return
      this._storage.setItem(this._configuracao, JSON.stringify(conf))
      return true
    } catch(error) {
      this.logout()
      return null
    }
  }

  getConfiguracao() {
    if (!this.isLoggedIn()) return
    try {
      const configuracao = this._storage.getItem(this._configuracao)
      return JSON.parse(configuracao)
    } catch(error) {
      this.logout()
      return null
    }
  }

  /**
   * Retorna se a autenticação do usuário é válida
   */
  async validateToken() {
    if (!this.isLoggedIn()) return false;
    try {
      await api.execute('get', '/api/auth/gen204', null, { bearer: this.getBearerToken() });
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Retorna se um usuário possui dadas permissões.
   *
   * - Se chamada com um booleano como parâmetro, retorna este booleano, independentemente de haver usuário logado.
   * - Se for chamada com um array vazio, retorna `true` caso haja um usuário logado.
   * - Se for chamada com uma string, retorna `true` caso haja um usuário logado e ele tenha tal permissão.
   * - Se for chamada com um array,
   *     retorna `true` caso o usuário possua todas as permissões de algum dos elementos deste array
   * (já que cada elemento pode ser uma string ou um array de strings)
   *
   * @param {boolean|string|(string|string[])[]} permissions
   * @returns {boolean}
   */
  verifyPermissions(permissions = true) {
    if (typeof permissions === 'boolean') return permissions;
    const pPermissions = (typeof permissions === 'string') ? [permissions] : permissions;
    const user = this.getUser();

    if (!user || !user.permissoes) return false;
    if (pPermissions.length === 0) return true;

    const permMatcher = permMatch(user.permissoes);

    return arrayfy(permissions).some(permMatcher);
  }

  /**
   * Retorna se um usuário possui dadas permissões.
   *
   * - Se chamada com um booleano como parâmetro, retorna este booleano, independentemente de haver usuário logado.
   * - Se for chamada com um array vazio, retorna `true` caso haja um usuário logado.
   * - Se for chamada com uma string, retorna `true` caso haja um usuário logado e ele tenha tal permissão.
   * - Se for chamada com um array, retorna `true` caso o usuário possua todas as permissões de algum dos elementos deste array
   * (já que cada elemento pode ser uma string ou um array de strings)
   *
   * @param {boolean|string|(string|string[])[]} areas
   * @returns {boolean}
   */
  verifyAreas(areas = true) {
    if (typeof areas === 'boolean') return areas;
    const pAreas = (typeof areas === 'string') ? [areas] : areas;
    const user = this.getUser();

    if (!user || !user.permissoes) return false;
    if (pAreas.length === 0) return true;

    const permMatcher = permMatch(user.areas);

    return arrayfy(areas).some(permMatcher);
  }

  getBearerToken() {
    return this._storage.getItem(this._bearer);
  }
}

export default new LoginManager('/api/auth');
